function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { slideUp, slideDown, slideToggle } from "./utilities";
export function accordeon(el) {
  var accEl = document.querySelectorAll(el);

  var _iterator = _createForOfIteratorHelper(accEl),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _el = _step.value;

      // get Toggle Header
      var accHeader = _el.querySelector('.toggle');

      _el.querySelector('.toggle').remove(); // get Content


      var accBody = _el.innerHTML;
      _el.innerHTML = ''; // prepare toggler

      var toggler = document.createElement('div');
      toggler.classList.add('toggler');
      toggler.append(accHeader);
      var actions = "\n         <div class=\"actions\">\n            <button class=\"open\">\n               <svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\">\n                  <rect y=\"18\" width=\"40\" height=\"4\" rx=\"2\"/>\n                  <rect x=\"22\" width=\"40\" height=\"4\" rx=\"2\" transform=\"rotate(90 22 0)\"/>\n               </svg>\n            </button>\n            <button class=\"close\">\n                <svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\">\n                    <rect y=\"18\" width=\"40\" height=\"4\" rx=\"2\"/>\n               </svg>\n            </button>\n          \n         </div>\n      ";
      toggler.innerHTML += actions; // prepare body

      var body = document.createElement('div');
      body.classList.add('acc_body');
      var bodyInner = document.createElement('div');
      bodyInner.classList.add('acc_body_inner');
      bodyInner.innerHTML += accBody;
      body.append(bodyInner); // inject to DOM

      _el.append(toggler);

      _el.append(body);
      /* accordeon main function */


      toggler.addEventListener('click', function (e) {
        if (e.target.closest('.accordeon_item').classList.contains('active')) {
          e.target.closest('.accordeon_item').classList.remove('active');
          slideUp(e.target.closest('.accordeon_item').querySelector('.acc_body'), 100);
        } else {
          resetActive(e.target.closest('.accordeon_item'));
          e.target.closest('.accordeon_item').classList.add('active');
          slideDown(e.target.closest('.accordeon_item').querySelector('.acc_body'), 100);
        }
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  function resetActive() {
    var _iterator2 = _createForOfIteratorHelper(accEl),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var e = _step2.value;

        if (e.classList.contains('active')) {
          console.log(e);
          slideUp(e.querySelector('.acc_body'), 100);
        }

        e.classList.remove('active');
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
}